    <template>
      <div class="container pt-5 mt-2">
        <!--          上部分 -->
        <div class="address-detail">

          <!--          左部分-->
          <div class="address-box-left">
            <div class="address-box-icon token-box-icon">
              <img  v-if="tokenInfo && tokenInfo.iconUrl  " :src="tokenInfo.iconUrl"/>
              <img  v-else-if="tokenInfo && !tokenInfo.iconUrl && tokenInfo.type == 1 " src="../../images/token/erc-token-black.png"/>
              <img  v-else-if="tokenInfo && !tokenInfo.iconUrl && tokenInfo.type == 2 " src="../../images/token/nft-token-black.png"/>
            </div>
            <div v-if="tokenInfo" class="address-box-left-title">{{ tokenInfo.name }}</div>
            <div v-if="tokenInfo" class="token-box-left-text">{{ tokenInfo.symbol }}</div>
          </div>
          <!--          右部分-->
          <div class="address-box-right">
              <div class="token-box-right-detail">
                <div class="token-box-right-detail-title">Contract :</div>
                <div class="token-box-right-contarct d-flex flex-row align-items-center">
                  <span v-if="tokenInfo" class=""> <router-link :to="`/address/${updateAddress(tokenInfo.address).toLowerCase()}`">{{updateAddress(tokenInfo.address)}}</router-link></span>
                  <Copy :data="tokenInfo ? tokenInfo.address: ''"/>
                </div>
              </div>
            <div v-if="tokenInfo" class="token-box-right-detail token-box-right-details">
              <div class="token-box-right-detail-title">Total Supply :</div>
              <div v-if="tokenInfo && tokenInfo.type == 1" class="token-box-right-contarct">{{ parseFloat(parseDecimal(tokenInfo.totalSupply, tokenInfo.decimal)).toFixed(6) }} {{tokenInfo.symbol}}</div>
              <div v-else class="token-box-right-contarct">{{ parseFloat(tokenInfo.totalSupply)}} {{tokenInfo.symbol}}</div>
            </div>
            <div class="token-box-right-detail token-box-right-details">
              <div class="token-box-right-detail-title">Holders :</div>
              <div class="token-box-right-contarct"> {{ holders }} addresses</div>
            </div>
            <div class="token-box-right-detail token-box-right-details">
              <div class="token-box-right-detail-title">Transfers :</div>
              <div class="token-box-right-contarct"> {{ transactionCount }} transactions</div>
            </div>
            <div class="token-box-right-detail token-box-right-details">
              <div class="token-box-right-detail-title">Decimals :</div>
              <div v-if="tokenInfo" class="token-box-right-contarct"> {{ tokenInfo.decimal }} </div>
            </div>
          </div>

        </div>
        <!--            下部分-->
        <div class="address-tab">
          <div :class="showTab==0 ?'address-tab-text-click':''" @click="showTab=0" class="address-tab-text address-tab-text-one">Token Transfers</div>
          <div :class="showTab==1 ?'address-tab-text-click':''"  @click="showTab=1" class="address-tab-text address-tab-text-one" style="margin-left: 30px">Token Holders</div>
          <div v-if="tokenInfo && tokenInfo.type == 2" :class="showTab==3 ?'address-tab-text-click':''"  @click="showTab=3" class="address-tab-text address-tab-text-four" style="margin-left: 25px">NFTs</div>
        </div>

        <div v-show="showTab==0" class="address-total address-total-one">
          <div>
            <span>Total txs</span>
            <span>Show 10 latest records</span>
          </div>
          <router-link :to="`/tokenTrans/${address}`">
            <div class="address-box-right-view">
              <span><img src="../../images/address/view.png"/></span>
              View all Token Transfers
            </div>
          </router-link>
        </div>
        <div v-show="showTab==0">
          <TokenErcTransactionTable v-if="tokenInfo"  :cfg="cfg" :tokenInfo="tokenInfo" :top="1"/>
        </div>

        <div v-show="showTab==1" class="address-total address-total-one">
          <div>
            <span>Total Address</span>
            <span>Show 10 latest records</span>
          </div>
          <router-link :to="`/tokenHolders/${address}`">
            <div class="address-box-right-view">
              <span><img src="../../images/address/view.png"/></span>
              View all Token Holders
            </div>
          </router-link>
        </div>
        <div v-show="showTab==1">
          <TokenHoldersTable v-if="tokenInfo" :cfg="cfg" :tokenInfo="tokenInfo" :top="1"/>
        </div>

        <div v-show="showTab==3" class="address-total address-total-one">
          <div>
            <span>Total NFTs</span>
            <span>Show 10 latest records</span>
          </div>
          <router-link :to="`/nft/${address}`">
            <div class="address-box-right-view">
              <span><img src="../../images/address/view.png"/></span>
              View all NFTs
            </div>
          </router-link>
        </div>
        <div v-show="showTab==3">
          <TokenNft v-if="tokenInfo"  :cfg="cfg" :top="1"/>
        </div>


      </div>
    </template>

    <script>
    import TokenHoldersTable from "@/views/comp_table/token_holders_table";
    import { Decimal } from 'decimal.js'
    import { isNumber,updateAddress } from '@/util/index'
    import Copy from "@/views/_frame/copy";
    import TokenErcTransactionTable from "@/views/_comp_token/token_erc_transaction_table";
    import Token_Inventory from "@/views/_comp_token/token_inventory_table";
    import TokenInventory from "@/views/_comp_token/token_inventory_table";
    import TokenNft from "@/views/_comp_token/token_nft_table";
    export default {
      name: "index",
      components: {TokenNft, TokenInventory, Token_Inventory, TokenErcTransactionTable, Copy, TokenHoldersTable,},
      data() {
        return {
          cfg:{
            'page_size': 10, //每页条目数量
            'page_current': 1, // 当前页
            'count_items': 0, //总个数，和总页数选填其一
            'btn_num': 5, // 按钮个数
            'turnpage_top': true, // 翻页时操作滚动置顶
            'count_pages':0, //总页数，和个页数选填其一 // 默认请给 0 值-便于首次加载时不露出分页器
          },
          holders: 0,
          transactionCount: 0,
          tokenInfo: null,
          address:'',//地址
          showTab:0,//判断tab显示
          tokenList:null,
          tokenHoldesList:null
        }
      },
      methods:{
        //转换地址
        updateAddress(val){
          if (!val) {
            return
          }
          return  updateAddress(val)
        },
        parseDecimal(val, decimal){
          if(!isNumber(val)){
            return 0
          }
          return new Decimal(val).div(new Decimal(10).pow(new Decimal(decimal)));
        },

        async getTokenInfo(){

          let v = this
          let result = await v.api('tokenInfo',{
            address : v.address
          },{
            vue: v,
            key_data: 'data',
          })
          // console.log('getTokenInfo',result)
          if (result.code==200) {
            v.tokenInfo = result.data.tokenInfo
            v.holders = result.data.holders
            v.transactionCount = result.data.transactionCount
            // v.getTokenList();
            await v.getTokenHoderList();
          }
        },
        async getTokenList(){
          let v = this;
          let result = await v.api('tokenList', {
            page: 1,
            size: 10,
            address : v.address,
            type: v.tokenInfo.type
          }, {
            vue: v,
            key_data: 'data',
          })
          // console.log('getTokenList',result)
          if (result.code==200) {
            v.tokenList = result.data.list
          }
          // console.log(v.tokenList, "v.tokenList")
        },
        async getTokenHoderList(){
          let v = this;
          let result = await v.api('tokenHoderList', {
            page: 1,
            size: 10,
            address : v.address,
            type: v.tokenInfo.type
          }, {
            vue: v,
            key_data: 'data',
          })
          // console.log('getTokenHoderList',result)
          if (result.code==200) {
            v.tokenHoldesList = result.data.list
          }
        }
      },
      mounted() {
        this.address = this.$route.params.number
        this.getTokenInfo();
      },
    }
    </script>

    <style scoped lang="scss">

    .address-detail {
      height: 260px;
      background: url("../../images/address/box-bg-two.png")no-repeat;
      background-size: 100% 100%;
    }

    .token-box-left-text {
      padding-top: 3px;
      font-size: 13px;
    }

    .address-box-right {
      padding-top: 40px;
    }

    .token-box-right-detail {
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    .token-box-right-details {
      padding-top: 17px;
    }


    .token-box-right-detail-title {
      font-family: 'poppinSemiBold';
      font-weight: 600;
      font-size: 13px;
      width: 20%;
    }

    .token-box-right-contarct {
      font-size: 13px;
      img{
        width: 10px;
      }
      span {
        padding-left: 5px;
        color: #E44E3A;
      }
    }



    .address-tab-text-one {
      width: 160px;
    }


    </style>
